var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogout = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.892 2.92a5.5 5.5 0 1 1-2.64 7.857.5.5 0 0 0-.862.505A6.5 6.5 0 1 0 2.37 4.75a.5.5 0 1 0 .866.5 5.5 5.5 0 0 1 2.655-2.33Zm4.462 4.726a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L8.793 8.5H2a.5.5 0 0 1 0-1h6.793L6.646 5.354a.5.5 0 1 1 .708-.708l3 3Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogout);
export default ForwardRef;